class MagneticCover {
  constructor(element, trailsContainer) {
    this.element = element;
    this.elementsTrails = createTrails(4, trailsContainer);

    document.addEventListener("mousemove", (e) =>
      magnetize(this.element, this.elementsTrails, { mX: e.pageX, mY: e.pageY })
    );
    // document.addEventListener("touch", (e) =>
    //   magnetize(this.element, this.elementsTrails, {mX: e.pageX, mY: e.pageY})
    // );
    document.addEventListener(
      "touchmove",
      (e) => {

        // If there's exactly one finger inside this element
        if (e.targetTouches.length == 1) {
          e.preventDefault();
          var touch = event.targetTouches[0];
          magnetize(this.element, this.elementsTrails, {
            mX: touch.pageX,
            mY: touch.pageY,
          });
        }
      }
    );

    document.addEventListener(
      "touchend",
      (e) => {
        resetMagnetize(this.element, this.elementsTrails);
      })

    function magnetize(el, elTrails, { mX, mY }) {
      const item = el;
      const itemRect = el.getBoundingClientRect();

      const customDist = (itemRect.width + itemRect.height) / 3;
      const centerX = itemRect.left + itemRect.width / 2;
      const centerY = itemRect.top + itemRect.height / 2;

      var deltaX = Math.floor(centerX - mX) * -0.45;
      var deltaY = Math.floor(centerY - mY) * -0.45;

      var distance = calculateDistance(itemRect, mX, mY);

      if (distance < customDist) {
        setStopScroll(true);
        item.style.transform = `translate3D(${deltaX}px, ${deltaY}px, 0) rotate(${
          deltaX * 0.05
        }deg)`;
        elTrails.forEach(
          (el) =>
            (el.style.transform = `translate3D(${deltaX}px, ${deltaY}px, 0) 
              rotate(${deltaX * 0.05}deg)`)
        );
        item.classList.add("magnet");
      } else {
        resetMagnetize(item, elTrails);
      }
    }

    function resetMagnetize(item, trails) {
      item.style.transform = `translate3D(0px, 0px, 0) rotate(0deg)`;
      trails.forEach(
        (el) => (el.style.transform = `translate3D(0px, 0px, 0) rotate(0deg)`)
      );
      item.classList.remove("magnet");
      setStopScroll(false);
    }

    function setStopScroll(value) {

      if(document.body.classList.contains('stop-scroll')) {
        if(!value) document.body.classList.remove("stop-scroll");  
      } else if(value) {
        document.body.classList.add("stop-scroll");  
      }

    }

    function createTrails(number, container) {
      let trails = [];
      for (var i = 0; i < number; i++) {
        const div = document.createElement("div");
        container.append(div);
        trails.push(div);
      }
      return trails;
    }

    function calculateDistance(itemRect, mouseX, mouseY) {
      return Math.floor(
        Math.sqrt(
          Math.pow(mouseX - (itemRect.left + itemRect.width / 2), 2) +
            Math.pow(mouseY - (itemRect.top + itemRect.height / 2), 2)
        )
      );
    }

    /*- MOUSE STICKY -*/
    function lerp(a, b, n) {
      return (1 - n) * a + n * b;
    }
  }
}
export default MagneticCover;
